export const printSalesPaymentEnglish = (paymentData) => {
  const printWindow = window.open('', '_blank');
  
  const currencySymbol = paymentData?.currencySymbol || 'AF';
  
  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Sale Payment Receipt</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Arial', sans-serif; 
          font-size: 12px;
          line-height: 1.4;
          width: 148mm;
          margin: 0;
          padding: 0;
          background: white;
        }
        .receipt { 
          width: 100%;
          text-align: center;
          border: 1px solid #000;
          padding: 10px;
        }
        .company-name { 
          font-size: 16px; 
          font-weight: bold; 
          margin-bottom: 3px;
        }
        .contact-info { 
          font-size: 10px; 
          margin-bottom: 2px;
        }
        .receipt-title { 
          font-size: 14px; 
          font-weight: bold; 
          margin: 10px 0;
          text-transform: uppercase;
          background: #f0f0f0;
          padding: 5px;
        }
        .info-row { 
          display: flex; 
          justify-content: space-between; 
          margin: 3px 0;
          font-size: 11px;
          padding: 2px;
        }
        .label { 
          font-weight: bold; 
        }
        .dashed-line { 
          border-top: 1px dashed #000; 
          margin: 8px 0; 
        }
        .signature-section {
          margin-top: 15px;
          text-align: left;
        }
        .signature-line {
          border-bottom: 1px solid #000;
          height: 30px;
          margin: 5px 0;
        }
        .footer {
          margin-top: 10px;
          font-size: 9px;
          text-align: center;
        }
        @media print {
          body { 
            width: 148mm; 
            margin: 0; 
            padding: 0;
          }
          @page { 
            size: A5; 
            margin: 0; 
          }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="company-name">Brotheran Qadari</div>
        <div class="contact-info">📞 +93 70 285 0840 - +93 70 44 56 11 94</div>
        
        <div class="receipt-title">Payment Receipt</div>
        
        <div class="info-row">
          <span class="label">Receipt No:</span>
          <span>${paymentData?.invoiceNumber || Math.floor(Math.random() * 9999)}</span>
        </div>
        <div class="info-row">
          <span class="label">Date:</span>
          <span>${paymentData?.date || new Date().toLocaleDateString()}</span>
        </div>
        <div class="info-row">
          <span class="label">Time:</span>
          <span>${new Date().toLocaleTimeString()}</span>
        </div>
        
        <div class="dashed-line"></div>
        
        <div class="info-row">
          <span class="label">Customer:</span>
          <span>${paymentData?.customerName || 'Cash Customer'}</span>
        </div>
        <div class="info-row">
          <span class="label">Amount:</span>
          <span>${paymentData?.requestedAmount || '0.00'} ${currencySymbol}</span>
        </div>
        <div class="info-row">
          <span class="label">Currency:</span>
          <span>${currencySymbol}</span>
        </div>
        
        <div class="dashed-line"></div>
        
        <div class="signature-section">
          <div>Customer Signature:</div>
          <div class="signature-line"></div>
        </div>
        
        <div class="footer">
          <div>Thank you for your business!</div>
          <div>${new Date().getFullYear()} © Brotheran Qadari</div>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 500);
        };
      </script>
    </body>
    </html>
  `;
  
  printWindow.document.write(printContent);
  printWindow.document.close();
};

// A5 English payment receipt function for sale data
export const printSalePaymentEnglish = (sale) => {
  const printWindow = window.open('', '_blank');
  
  const currencySymbol = sale.currency_details?.symbol || sale.currency_details?.title || 'AF';
  
  const formatCurrency = (currencyObj) => {
    if (!currencyObj) return "0.00";
    if (typeof currencyObj === 'object') {
      return String(Object.values(currencyObj)[0] || "0.00");
    }
    return String(currencyObj);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  
  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="UTF-8">
      <title>Sale Payment Receipt</title>
      <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }
        body { 
          font-family: 'Arial', sans-serif; 
          font-size: 12px;
          line-height: 1.4;
          width: 148mm;
          margin: 0;
          padding: 0;
          background: white;
        }
        .receipt { 
          width: 100%;
          text-align: center;
          border: 1px solid #000;
          padding: 10px;
        }
        .company-name { 
          font-size: 16px; 
          font-weight: bold; 
          margin-bottom: 3px;
        }
        .contact-info { 
          font-size: 10px; 
          margin-bottom: 2px;
        }
        .receipt-title { 
          font-size: 14px; 
          font-weight: bold; 
          margin: 10px 0;
          text-transform: uppercase;
          background: #f0f0f0;
          padding: 5px;
        }
        .info-row { 
          display: flex; 
          justify-content: space-between; 
          margin: 3px 0;
          font-size: 11px;
          padding: 2px;
        }
        .label { 
          font-weight: bold; 
        }
        .dashed-line { 
          border-top: 1px dashed #000; 
          margin: 8px 0; 
        }
        .signature-section {
          margin-top: 15px;
          text-align: left;
        }
        .signature-line {
          border-bottom: 1px solid #000;
          height: 30px;
          margin: 5px 0;
        }
        .footer {
          margin-top: 10px;
          font-size: 9px;
          text-align: center;
        }
        @media print {
          body { 
            width: 148mm; 
            margin: 0; 
            padding: 0;
          }
          @page { 
            size: A5; 
            margin: 0; 
          }
        }
      </style>
    </head>
    <body>
      <div class="receipt">
        <div class="company-name">${sale.shop_details?.name || 'Brotheran Qadari'}</div>
        <div class="contact-info">📞 +93 70 285 0840 - +93 70 44 56 11 94</div>
        
        <div class="receipt-title">Sale Payment Receipt</div>
        
        <div class="info-row">
          <span class="label">Receipt #:</span>
          <span>${sale.id}</span>
        </div>
        <div class="info-row">
          <span class="label">Date:</span>
          <span>${formatDate(sale.sale_date)}</span>
        </div>
        <div class="info-row">
          <span class="label">Time:</span>
          <span>${new Date().toLocaleTimeString()}</span>
        </div>
        
        <div class="dashed-line"></div>
        
        <div class="info-row">
          <span class="label">Customer:</span>
          <span>${sale.customer_details?.name || 'Cash Customer'}</span>
        </div>
        <div class="info-row">
          <span class="label">Total Amount:</span>
          <span>${formatCurrency(sale.effective_total_amount)} ${currencySymbol}</span>
        </div>
        <div class="info-row">
          <span class="label">Amount Paid:</span>
          <span>${formatCurrency(sale.total_paid)} ${currencySymbol}</span>
        </div>
        <div class="info-row">
          <span class="label">Balance:</span>
          <span>${formatCurrency(sale.total_remained_amount)} ${currencySymbol}</span>
        </div>
        
        <div class="dashed-line"></div>
        
        <div class="signature-section">
          <div>Customer Signature:</div>
          <div class="signature-line"></div>
        </div>
        
        <div class="footer">
          <div>Thank you for your business!</div>
          <div>${new Date().getFullYear()} © Brotheran Qadari</div>
        </div>
      </div>
      
      <script>
        window.onload = function() {
          setTimeout(() => {
            window.print();
            window.close();
          }, 500);
        };
      </script>
    </body>
    </html>
  `;
  
  printWindow.document.write(printContent);
  printWindow.document.close();
};
